import { render, staticRenderFns } from "./CollectionCrudTrash.vue?vue&type=template&id=32e25ea7"
import script from "./CollectionCrudTrash.vue?vue&type=script&lang=js"
export * from "./CollectionCrudTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports